import React, { useState } from 'react';
import { Container, TextField, Typography, Grid, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Colors } from '../../Styles/Colors';

const denominations = [2000, 500, 200, 100, 50, 20, 10, 1];

const CashSplitter = () => {
    const [counts, setCounts] = useState(denominations.reduce((acc, val) => ({ ...acc, [val]: '' }), {}));
    const [total, setTotal] = useState(0);

    const handleCountChange = (denom, value) => {
        const newCounts = { ...counts, [denom]: value };
        setCounts(newCounts);
        calculateTotal(newCounts);
    };

    const calculateTotal = (counts) => {
        const totalAmount = denominations.reduce((sum, denom) => sum + (counts[denom] ? parseInt(counts[denom]) * denom : 0), 0);
        setTotal(totalAmount);
    };

    return (
        <Accordion sx={{backgroundColor:Colors.Background}} elevation={1}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography fontSize={'0.9rem'} fontWeight={600}>Cash Denomination</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container spacing={2} justifyContent="center">
                    {denominations.map((denom) => (
                        <Grid item xs={12} sm={6} md={6} key={denom}>
                            <Grid container alignItems="center" spacing={1}>
                                <Grid item xs={4}>
                                    <Typography>{`${denom} x`}</Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <TextField
                                        autoComplete='off'
                                        value={counts[denom]}
                                        onChange={(e) => handleCountChange(denom, e.target.value)}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        InputProps={{ style: { height: '4.5dvh' } }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    ))}
                </Grid>
                <Typography fontSize={'0.9rem'} fontWeight={600} style={{ marginTop: '20px', textAlign: 'center' }}>
                    Total Amount: {total}
                </Typography>
            </AccordionDetails>
        </Accordion>
    );
};

export default CashSplitter;
